module.exports = __webpack_public_path__ + "static/media/Arachno - A Sad Touch.8c52287d.mp3";